export const UPDATE_USER_DETAILS = 'tempUserDetails/UPDATE_USER_DETAILS'
export const RESET = 'tempUserDetails/RESET'
